<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-accounting-equipments-detail [pk]="pk" [mode]="mode" [defaults]="defaults"
                                   (detailSaved)="modal.close($event)"
                                   (detailCancelled)="modal.dismiss()">
    </app-accounting-equipments-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-accounting-equipments-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                                  [disabledButtons]="localDisabledButtons" [disabledColumns]="disabledColumns"
                                  [filters]="filters" [disableRouterLink]="true">
    </app-accounting-equipments-list>
  </ng-template>
</div>